import React, { useEffect, useState } from "react";

// A credencial em texto plano do cliente. O calculator-api a guarda sem hash, e
// tem a troca por hash em backlog — o que aparece aqui é o segredo real, não um
// hint.
//
// Mascarada por default, sempre: se nascesse revelada, ninguém notaria até vazar
// num print de tela ou numa apresentação. Revelar é ação explícita.
//
// NÃO tem botão de rotação: o contrato do backend proíbe pôr rotacionar ao lado
// de copiar, para os dois não serem confundidos. A rotação mora na lista.
export default function ApiKeyReveal({ clientName, apiKey }) {
  const [revealed, setRevealed] = useState(false);
  const [copied, setCopied] = useState(false);

  // A tela troca a key sem desmontar este componente (ver key, rotacionar, criar
  // outro cliente), e sem este reset o `revealed` de um cliente vazaria a key do
  // seguinte já em texto plano — mascarar por default vale por key, não por
  // montagem.
  useEffect(() => {
    setRevealed(false);
    setCopied(false);
  }, [apiKey]);

  if (!apiKey) return null;

  // prefixo preservado porque é o que identifica a key sem expô-la
  const masked = `${apiKey.slice(0, 6)}${"•".repeat(20)}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
    } catch (error) {
      // clipboard bloqueado (contexto não seguro, permissão negada): revelar e
      // copiar à mão continua funcionando, então não vale alarme
      setRevealed(true);
    }
  };

  return (
    <div className="alert alert-custom alert-light-success" role="alert">
      <div className="alert-text">
        <p className="mb-2">
          <strong>API key de {clientName}</strong>
        </p>

        <code className="d-block mb-3" style={{ wordBreak: "break-all" }}>
          {revealed ? apiKey : masked}
        </code>

        <button
          type="button"
          className="btn btn-sm btn-light mr-2"
          onClick={() => setRevealed(!revealed)}
        >
          {revealed ? "Ocultar" : "Revelar"}
        </button>
        <button
          type="button"
          className="btn btn-sm btn-light"
          onClick={copyToClipboard}
        >
          {copied ? "Copiado" : "Copiar"}
        </button>

        <p className="text-muted mt-3 mb-0">
          <small>
            Repasse por canal seguro. A key não fica salva nesta tela — sai ao
            trocar de aba ou recarregar, e pode ser reexibida pela lista.
          </small>
        </p>
      </div>
    </div>
  );
}
